/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { GraphQLContext } from './context';
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from './hooks';
export type Maybe<T> = T | null;
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  Date: string,
  Upload: any,
};

export type AudioContent = {
  readonly __typename: 'AudioContent',
  readonly id: Scalars['ID'],
  readonly audio: StoredAsset,
};

export type Case = {
  readonly __typename: 'Case',
  readonly id: Scalars['ID'],
  readonly createdAt: Scalars['Date'],
  readonly initialMessages: ReadonlyArray<Message>,
  readonly topic: ConversationTopic,
  readonly title: Scalars['String'],
};

export type Client = User & {
  readonly __typename: 'Client',
  readonly id: Scalars['ID'],
  readonly isMe: Scalars['Boolean'],
};

export type Content = AudioContent | ImageContent | TextContent;

export type Conversation = {
  readonly __typename: 'Conversation',
  readonly id: Scalars['ID'],
  readonly case: Case,
  readonly client: Client,
  readonly lawyer?: Maybe<Lawyer>,
  readonly status: ConversationStatus,
  readonly createdAt: Scalars['Date'],
  readonly lastMessage?: Maybe<Message>,
  readonly lastMessageUpdatedAt: Scalars['Date'],
  readonly updatedAt: Scalars['Date'],
};

export type ConversationEvent = {
  readonly __typename: 'ConversationEvent',
  readonly type: EventType,
  readonly conversation: Conversation,
};

export type ConversationStatus = 
  'InformationGathering' |
  'LookingForLawyer' |
  'InProgress' |
  'Resolved';

export type ConversationTopic = {
  readonly __typename: 'ConversationTopic',
  readonly id: Scalars['ID'],
  readonly category: ConversationTopicCategory,
  readonly examples: ReadonlyArray<GettingStartedExample>,
  readonly name: Scalars['String'],
  readonly description?: Maybe<Scalars['String']>,
  readonly icon?: Maybe<Scalars['String']>,
};

export type ConversationTopicCategory = {
  readonly __typename: 'ConversationTopicCategory',
  readonly id: Scalars['ID'],
  readonly name: Scalars['String'],
  readonly topics: ReadonlyArray<ConversationTopic>,
  readonly description?: Maybe<Scalars['String']>,
  readonly icon?: Maybe<Scalars['String']>,
};

export type CurrentUser = {
  readonly __typename: 'CurrentUser',
  readonly hasNotificationAccess: Scalars['Boolean'],
  readonly phoneNumber: Scalars['String'],
  readonly status: UserStatus,
  readonly user: User,
};


export type EventType = 
  'added' |
  'removed' |
  'updated';

export type GettingStartedExample = {
  readonly __typename: 'GettingStartedExample',
  readonly id: Scalars['ID'],
  readonly topic: ConversationTopic,
  readonly question: Scalars['String'],
};

export type ImageContent = {
  readonly __typename: 'ImageContent',
  readonly id: Scalars['ID'],
  readonly image: StoredAsset,
};

export type Lawyer = User & {
  readonly __typename: 'Lawyer',
  readonly id: Scalars['ID'],
  readonly isMe: Scalars['Boolean'],
  readonly lawyerTitle?: Maybe<Scalars['String']>,
};

export type Message = {
  readonly __typename: 'Message',
  readonly id: Scalars['ID'],
  readonly author: User,
  readonly createdAt: Scalars['Date'],
  readonly content: Content,
  readonly conversation: Conversation,
  readonly updatedAt: Scalars['Date'],
};

export type MessageEvent = {
  readonly __typename: 'MessageEvent',
  readonly type: EventType,
  readonly message: Message,
};

export type Mutation = {
  readonly __typename: 'Mutation',
  readonly register?: Maybe<RegisterOutput>,
  readonly registerLawyer?: Maybe<RegisterOutput>,
  readonly login?: Maybe<Scalars['String']>,
  readonly logout?: Maybe<Scalars['String']>,
  readonly sendNewPhoneNumberToken?: Maybe<Scalars['Date']>,
  readonly submitPhoneNumberToken?: Maybe<Scalars['String']>,
  readonly submitNotificationToken?: Maybe<Scalars['String']>,
  readonly createConversation?: Maybe<Conversation>,
  readonly markConversationAsLookingForLawyer?: Maybe<Conversation>,
  readonly removeConversation?: Maybe<Conversation>,
  readonly sendMessage?: Maybe<Message>,
  readonly removeMessage?: Maybe<Message>,
  readonly undoRemoveMessage?: Maybe<Message>,
  readonly editTextMessage?: Maybe<Message>,
  readonly acceptCase?: Maybe<Case>,
  readonly resolveCase?: Maybe<Conversation>,
  readonly unresolveCase?: Maybe<Conversation>,
};


export type MutationRegisterArgs = {
  phoneNumber: Scalars['String']
};


export type MutationRegisterLawyerArgs = {
  phoneNumber: Scalars['String'],
  inviteCode: Scalars['String']
};


export type MutationLoginArgs = {
  id: Scalars['ID'],
  token: Scalars['String']
};


export type MutationLogoutArgs = {
  token: Scalars['String']
};


export type MutationSubmitPhoneNumberTokenArgs = {
  token: Scalars['String']
};


export type MutationSubmitNotificationTokenArgs = {
  token: Scalars['String']
};


export type MutationCreateConversationArgs = {
  title: Scalars['String'],
  topicId: Scalars['ID']
};


export type MutationMarkConversationAsLookingForLawyerArgs = {
  id: Scalars['ID']
};


export type MutationRemoveConversationArgs = {
  id: Scalars['ID']
};


export type MutationSendMessageArgs = {
  conversationId: Scalars['ID'],
  textContent?: Maybe<Scalars['String']>,
  imageContent?: Maybe<Scalars['Upload']>,
  voiceContent?: Maybe<Scalars['Upload']>
};


export type MutationRemoveMessageArgs = {
  id: Scalars['ID']
};


export type MutationUndoRemoveMessageArgs = {
  id: Scalars['ID']
};


export type MutationEditTextMessageArgs = {
  id: Scalars['ID'],
  textContent: Scalars['String']
};


export type MutationAcceptCaseArgs = {
  id: Scalars['ID']
};


export type MutationResolveCaseArgs = {
  id: Scalars['ID']
};


export type MutationUnresolveCaseArgs = {
  id: Scalars['ID']
};

export type PendingCaseEvent = {
  readonly __typename: 'PendingCaseEvent',
  readonly pendingCase: Case,
};

export type Query = {
  readonly __typename: 'Query',
  readonly getTopicCategories?: Maybe<ReadonlyArray<ConversationTopicCategory>>,
  readonly currentUser?: Maybe<CurrentUser>,
  readonly getPendingCases?: Maybe<ReadonlyArray<Case>>,
  readonly getMessage?: Maybe<Message>,
  readonly getMessages?: Maybe<ReadonlyArray<Message>>,
  readonly getConversation?: Maybe<Conversation>,
  readonly getConversations?: Maybe<ReadonlyArray<Conversation>>,
};


export type QueryGetPendingCasesArgs = {
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryGetMessageArgs = {
  id: Scalars['ID']
};


export type QueryGetMessagesArgs = {
  conversationId: Scalars['ID'],
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type QueryGetConversationArgs = {
  id: Scalars['ID']
};


export type QueryGetConversationsArgs = {
  status?: Maybe<ReadonlyArray<ConversationStatus>>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};

export type RegisterOutput = {
  readonly __typename: 'RegisterOutput',
  readonly id: Scalars['ID'],
  readonly jwtToken: Scalars['String'],
  readonly refreshToken: Scalars['String'],
};

export type StoredAsset = {
  readonly __typename: 'StoredAsset',
  readonly presignedUrl: Scalars['String'],
};

export type Subscription = {
  readonly __typename: 'Subscription',
  readonly conversations?: Maybe<ConversationEvent>,
  readonly conversation?: Maybe<Conversation>,
  readonly messages?: Maybe<MessageEvent>,
  readonly pendingCase?: Maybe<PendingCaseEvent>,
};


export type SubscriptionConversationsArgs = {
  eventTypes?: Maybe<ReadonlyArray<EventType>>,
  status?: Maybe<ReadonlyArray<ConversationStatus>>
};


export type SubscriptionConversationArgs = {
  id: Scalars['ID']
};


export type SubscriptionMessagesArgs = {
  conversationId: Scalars['ID'],
  eventTypes?: Maybe<ReadonlyArray<EventType>>
};

export type TextContent = {
  readonly __typename: 'TextContent',
  readonly id: Scalars['ID'],
  readonly content: Scalars['String'],
};


export type User = {
  readonly id: Scalars['ID'],
  readonly isMe: Scalars['Boolean'],
};

export type UserStatus = 
  'NotVerified' |
  'Verified';

export type MessageInfoFragment = (
  { readonly __typename: 'Message' }
  & Pick<Message, 'id' | 'createdAt' | 'updatedAt'>
  & { readonly content: (
    { readonly __typename: 'AudioContent' }
    & Pick<AudioContent, 'id'>
    & { readonly audio: (
      { readonly __typename: 'StoredAsset' }
      & Pick<StoredAsset, 'presignedUrl'>
    ) }
  ) | (
    { readonly __typename: 'ImageContent' }
    & Pick<ImageContent, 'id'>
    & { readonly image: (
      { readonly __typename: 'StoredAsset' }
      & Pick<StoredAsset, 'presignedUrl'>
    ) }
  ) | (
    { readonly __typename: 'TextContent' }
    & Pick<TextContent, 'id' | 'content'>
  ), readonly conversation: (
    { readonly __typename: 'Conversation' }
    & Pick<Conversation, 'id'>
    & { readonly lastMessage: Maybe<(
      { readonly __typename: 'Message' }
      & Pick<Message, 'id'>
    )> }
  ), readonly author: (
    { readonly __typename: 'Client' }
    & Pick<Client, 'id' | 'isMe'>
  ) | (
    { readonly __typename: 'Lawyer' }
    & Pick<Lawyer, 'id' | 'isMe'>
  ) }
);

export type LastMessageFragment = (
  { readonly __typename: 'Conversation' }
  & Pick<Conversation, 'lastMessageUpdatedAt'>
  & { readonly lastMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type GettingStartedExampleInfoFragment = (
  { readonly __typename: 'GettingStartedExample' }
  & Pick<GettingStartedExample, 'id' | 'question'>
  & { readonly topic: (
    { readonly __typename: 'ConversationTopic' }
    & ConversationTopicInfoFragment
  ) }
);

export type GettingStartedExampleInfoMinimalFragment = (
  { readonly __typename: 'GettingStartedExample' }
  & Pick<GettingStartedExample, 'id' | 'question'>
  & { readonly topic: (
    { readonly __typename: 'ConversationTopic' }
    & Pick<ConversationTopic, 'id'>
  ) }
);

export type ConversationTopicInfoFragment = (
  { readonly __typename: 'ConversationTopic' }
  & Pick<ConversationTopic, 'id' | 'name' | 'description' | 'icon'>
  & { readonly category: (
    { readonly __typename: 'ConversationTopicCategory' }
    & ConversationTopicCategoryInfoMinimalFragment
  ) }
);

export type CaseInfoFragment = (
  { readonly __typename: 'Case' }
  & Pick<Case, 'id' | 'createdAt' | 'title'>
  & { readonly topic: (
    { readonly __typename: 'ConversationTopic' }
    & ConversationTopicInfoFragment
  ) }
);

export type CaseInfoWithInitialMessagesFragment = (
  { readonly __typename: 'Case' }
  & { readonly initialMessages: ReadonlyArray<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
  & CaseInfoFragment
);

export type ConversationInfoFragment = (
  { readonly __typename: 'Conversation' }
  & Pick<Conversation, 'id' | 'status' | 'updatedAt'>
  & { readonly case: (
    { readonly __typename: 'Case' }
    & CaseInfoFragment
  ), readonly client: (
    { readonly __typename: 'Client' }
    & Pick<Client, 'id' | 'isMe'>
  ), readonly lawyer: Maybe<(
    { readonly __typename: 'Lawyer' }
    & Pick<Lawyer, 'id' | 'isMe' | 'lawyerTitle'>
  )> }
  & LastMessageFragment
);

export type ConversationTopicCategoryInfoMinimalFragment = (
  { readonly __typename: 'ConversationTopicCategory' }
  & Pick<ConversationTopicCategory, 'id' | 'name' | 'description' | 'icon'>
);

export type ConversationTopicCategoryInfoFragment = (
  { readonly __typename: 'ConversationTopicCategory' }
  & Pick<ConversationTopicCategory, 'id' | 'name' | 'description' | 'icon'>
  & { readonly topics: ReadonlyArray<(
    { readonly __typename: 'ConversationTopic' }
    & { readonly examples: ReadonlyArray<(
      { readonly __typename: 'GettingStartedExample' }
      & GettingStartedExampleInfoMinimalFragment
    )> }
    & ConversationTopicInfoFragment
  )> }
);

export type GetConversationsQueryVariables = {
  status?: Maybe<ReadonlyArray<ConversationStatus>>,
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type GetConversationsQuery = (
  { readonly __typename: 'Query' }
  & { readonly getConversations: Maybe<ReadonlyArray<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )>> }
);

export type GetMessagesQueryVariables = {
  conversationId: Scalars['ID'],
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type GetMessagesQuery = (
  { readonly __typename: 'Query' }
  & { readonly getMessages: Maybe<ReadonlyArray<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )>> }
);

export type GetPendingCasesQueryVariables = {
  offset?: Maybe<Scalars['Int']>,
  limit?: Maybe<Scalars['Int']>
};


export type GetPendingCasesQuery = (
  { readonly __typename: 'Query' }
  & { readonly getPendingCases: Maybe<ReadonlyArray<(
    { readonly __typename: 'Case' }
    & CaseInfoWithInitialMessagesFragment
  )>> }
);

export type CurrentUserQueryVariables = {};


export type CurrentUserQuery = (
  { readonly __typename: 'Query' }
  & { readonly currentUser: Maybe<(
    { readonly __typename: 'CurrentUser' }
    & Pick<CurrentUser, 'hasNotificationAccess' | 'phoneNumber' | 'status'>
    & { readonly user: (
      { readonly __typename: 'Client' }
      & Pick<Client, 'id'>
    ) | (
      { readonly __typename: 'Lawyer' }
      & Pick<Lawyer, 'id'>
    ) }
  )> }
);

export type GetTopicCategoriesQueryVariables = {};


export type GetTopicCategoriesQuery = (
  { readonly __typename: 'Query' }
  & { readonly getTopicCategories: Maybe<ReadonlyArray<(
    { readonly __typename: 'ConversationTopicCategory' }
    & ConversationTopicCategoryInfoFragment
  )>> }
);

export type GetConversationQueryVariables = {
  id: Scalars['ID']
};


export type GetConversationQuery = (
  { readonly __typename: 'Query' }
  & { readonly getConversation: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type GetMessageQueryVariables = {
  id: Scalars['ID']
};


export type GetMessageQuery = (
  { readonly __typename: 'Query' }
  & { readonly getMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type LoginMutationVariables = {
  id: Scalars['ID'],
  token: Scalars['String']
};


export type LoginMutation = (
  { readonly __typename: 'Mutation' }
  & Pick<Mutation, 'login'>
);

export type LogoutMutationVariables = {
  token: Scalars['String']
};


export type LogoutMutation = (
  { readonly __typename: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type RegisterMutationVariables = {
  phoneNumber: Scalars['String']
};


export type RegisterMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly register: Maybe<(
    { readonly __typename: 'RegisterOutput' }
    & Pick<RegisterOutput, 'id' | 'jwtToken' | 'refreshToken'>
  )> }
);

export type RegisterLawyerMutationVariables = {
  phoneNumber: Scalars['String'],
  inviteCode: Scalars['String']
};


export type RegisterLawyerMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly registerLawyer: Maybe<(
    { readonly __typename: 'RegisterOutput' }
    & Pick<RegisterOutput, 'id' | 'jwtToken' | 'refreshToken'>
  )> }
);

export type SendNewPhoneNumberTokenMutationVariables = {};


export type SendNewPhoneNumberTokenMutation = (
  { readonly __typename: 'Mutation' }
  & Pick<Mutation, 'sendNewPhoneNumberToken'>
);

export type SubmitPhoneNumberTokenMutationVariables = {
  token: Scalars['String']
};


export type SubmitPhoneNumberTokenMutation = (
  { readonly __typename: 'Mutation' }
  & Pick<Mutation, 'submitPhoneNumberToken'>
);

export type CreateConversationMutationVariables = {
  title: Scalars['String'],
  topicId: Scalars['ID']
};


export type CreateConversationMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly createConversation: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type MarkConversationAsLookingForLawyerMutationVariables = {
  id: Scalars['ID']
};


export type MarkConversationAsLookingForLawyerMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly markConversationAsLookingForLawyer: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type SendMessageMutationVariables = {
  conversationId: Scalars['ID'],
  textContent?: Maybe<Scalars['String']>,
  imageContent?: Maybe<Scalars['Upload']>,
  voiceContent?: Maybe<Scalars['Upload']>
};


export type SendMessageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly sendMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type RemoveMessageMutationVariables = {
  id: Scalars['ID']
};


export type RemoveMessageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly removeMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type UndoRemoveMessageMutationVariables = {
  id: Scalars['ID']
};


export type UndoRemoveMessageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly undoRemoveMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type EditTextMessageMutationVariables = {
  id: Scalars['ID'],
  textContent: Scalars['String']
};


export type EditTextMessageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly editTextMessage: Maybe<(
    { readonly __typename: 'Message' }
    & MessageInfoFragment
  )> }
);

export type RemoveConversationMutationVariables = {
  id: Scalars['ID']
};


export type RemoveConversationMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly removeConversation: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type SubmitNotificationTokenMutationVariables = {
  token: Scalars['String']
};


export type SubmitNotificationTokenMutation = (
  { readonly __typename: 'Mutation' }
  & Pick<Mutation, 'submitNotificationToken'>
);

export type AcceptCaseMutationVariables = {
  id: Scalars['ID']
};


export type AcceptCaseMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly acceptCase: Maybe<(
    { readonly __typename: 'Case' }
    & CaseInfoFragment
  )> }
);

export type ResolveCaseMutationVariables = {
  id: Scalars['ID']
};


export type ResolveCaseMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly resolveCase: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type UnresolveCaseMutationVariables = {
  id: Scalars['ID']
};


export type UnresolveCaseMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly unresolveCase: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type MessagesSubscriptionVariables = {
  conversationId: Scalars['ID']
};


export type MessagesSubscription = (
  { readonly __typename: 'Subscription' }
  & { readonly messages: Maybe<(
    { readonly __typename: 'MessageEvent' }
    & Pick<MessageEvent, 'type'>
    & { readonly message: (
      { readonly __typename: 'Message' }
      & MessageInfoFragment
    ) }
  )> }
);

export type ConversationsSubscriptionVariables = {
  status?: Maybe<ReadonlyArray<ConversationStatus>>
};


export type ConversationsSubscription = (
  { readonly __typename: 'Subscription' }
  & { readonly conversations: Maybe<(
    { readonly __typename: 'ConversationEvent' }
    & Pick<ConversationEvent, 'type'>
    & { readonly conversation: (
      { readonly __typename: 'Conversation' }
      & ConversationInfoFragment
    ) }
  )> }
);

export type ConversationSubscriptionVariables = {
  id: Scalars['ID']
};


export type ConversationSubscription = (
  { readonly __typename: 'Subscription' }
  & { readonly conversation: Maybe<(
    { readonly __typename: 'Conversation' }
    & ConversationInfoFragment
  )> }
);

export type PendingCaseSubscriptionVariables = {};


export type PendingCaseSubscription = (
  { readonly __typename: 'Subscription' }
  & { readonly pendingCase: Maybe<(
    { readonly __typename: 'PendingCaseEvent' }
    & { readonly pendingCase: (
      { readonly __typename: 'Case' }
      & CaseInfoWithInitialMessagesFragment
    ) }
  )> }
);

export const ConversationTopicCategoryInfoMinimalFragmentDoc = gql`
    fragment ConversationTopicCategoryInfoMinimal on ConversationTopicCategory {
  id
  name
  description
  icon
}
    `;
export const ConversationTopicInfoFragmentDoc = gql`
    fragment ConversationTopicInfo on ConversationTopic {
  id
  category {
    ...ConversationTopicCategoryInfoMinimal
  }
  name
  description
  icon
}
    ${ConversationTopicCategoryInfoMinimalFragmentDoc}`;
export const GettingStartedExampleInfoFragmentDoc = gql`
    fragment GettingStartedExampleInfo on GettingStartedExample {
  id
  question
  topic {
    ...ConversationTopicInfo
  }
}
    ${ConversationTopicInfoFragmentDoc}`;
export const CaseInfoFragmentDoc = gql`
    fragment CaseInfo on Case {
  id
  createdAt
  title
  topic {
    ...ConversationTopicInfo
  }
}
    ${ConversationTopicInfoFragmentDoc}`;
export const MessageInfoFragmentDoc = gql`
    fragment MessageInfo on Message {
  id
  content {
    __typename
    ... on AudioContent {
      id
      audio {
        presignedUrl
      }
    }
    ... on ImageContent {
      id
      image {
        presignedUrl
      }
    }
    ... on TextContent {
      id
      content
    }
  }
  createdAt
  conversation {
    id
    lastMessage {
      id
    }
  }
  updatedAt
  author {
    id
    isMe
  }
}
    `;
export const CaseInfoWithInitialMessagesFragmentDoc = gql`
    fragment CaseInfoWithInitialMessages on Case {
  ...CaseInfo
  initialMessages {
    ...MessageInfo
  }
}
    ${CaseInfoFragmentDoc}
${MessageInfoFragmentDoc}`;
export const LastMessageFragmentDoc = gql`
    fragment LastMessage on Conversation {
  lastMessageUpdatedAt
  lastMessage {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export const ConversationInfoFragmentDoc = gql`
    fragment ConversationInfo on Conversation {
  id
  case {
    ...CaseInfo
  }
  ...LastMessage
  status
  updatedAt
  client {
    id
    isMe
  }
  lawyer {
    id
    isMe
    lawyerTitle
  }
}
    ${CaseInfoFragmentDoc}
${LastMessageFragmentDoc}`;
export const GettingStartedExampleInfoMinimalFragmentDoc = gql`
    fragment GettingStartedExampleInfoMinimal on GettingStartedExample {
  id
  question
  topic {
    id
  }
}
    `;
export const ConversationTopicCategoryInfoFragmentDoc = gql`
    fragment ConversationTopicCategoryInfo on ConversationTopicCategory {
  id
  name
  description
  icon
  topics {
    ...ConversationTopicInfo
    examples {
      ...GettingStartedExampleInfoMinimal
    }
  }
}
    ${ConversationTopicInfoFragmentDoc}
${GettingStartedExampleInfoMinimalFragmentDoc}`;
export const GetConversationsDocument = gql`
    query getConversations($status: [ConversationStatus!], $offset: Int, $limit: Int) {
  getConversations(status: $status, offset: $offset, limit: $limit) @connection(key: "getConversations", filter: ["status"]) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, baseOptions);
      }
export function useGetConversationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, baseOptions);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsQueryResult = ApolloReactCommon.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const GetMessagesDocument = gql`
    query getMessages($conversationId: ID!, $offset: Int, $limit: Int) {
  getMessages(conversationId: $conversationId, offset: $offset, limit: $limit) @connection(key: "getMessages", filter: ["conversationId"]) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, baseOptions);
      }
export function useGetMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, baseOptions);
        }
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesQueryResult = ApolloReactCommon.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetPendingCasesDocument = gql`
    query getPendingCases($offset: Int, $limit: Int) {
  getPendingCases(offset: $offset, limit: $limit) @connection(key: "getPendingCases") {
    ...CaseInfoWithInitialMessages
  }
}
    ${CaseInfoWithInitialMessagesFragmentDoc}`;

/**
 * __useGetPendingCasesQuery__
 *
 * To run a query within a React component, call `useGetPendingCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingCasesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPendingCasesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPendingCasesQuery, GetPendingCasesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPendingCasesQuery, GetPendingCasesQueryVariables>(GetPendingCasesDocument, baseOptions);
      }
export function useGetPendingCasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPendingCasesQuery, GetPendingCasesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPendingCasesQuery, GetPendingCasesQueryVariables>(GetPendingCasesDocument, baseOptions);
        }
export type GetPendingCasesQueryHookResult = ReturnType<typeof useGetPendingCasesQuery>;
export type GetPendingCasesLazyQueryHookResult = ReturnType<typeof useGetPendingCasesLazyQuery>;
export type GetPendingCasesQueryResult = ApolloReactCommon.QueryResult<GetPendingCasesQuery, GetPendingCasesQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    hasNotificationAccess
    phoneNumber
    status
    user {
      id
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, baseOptions);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, baseOptions);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = ApolloReactCommon.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetTopicCategoriesDocument = gql`
    query getTopicCategories {
  getTopicCategories {
    ...ConversationTopicCategoryInfo
  }
}
    ${ConversationTopicCategoryInfoFragmentDoc}`;

/**
 * __useGetTopicCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTopicCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopicCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTopicCategoriesQuery, GetTopicCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetTopicCategoriesQuery, GetTopicCategoriesQueryVariables>(GetTopicCategoriesDocument, baseOptions);
      }
export function useGetTopicCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopicCategoriesQuery, GetTopicCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetTopicCategoriesQuery, GetTopicCategoriesQueryVariables>(GetTopicCategoriesDocument, baseOptions);
        }
export type GetTopicCategoriesQueryHookResult = ReturnType<typeof useGetTopicCategoriesQuery>;
export type GetTopicCategoriesLazyQueryHookResult = ReturnType<typeof useGetTopicCategoriesLazyQuery>;
export type GetTopicCategoriesQueryResult = ApolloReactCommon.QueryResult<GetTopicCategoriesQuery, GetTopicCategoriesQueryVariables>;
export const GetConversationDocument = gql`
    query getConversation($id: ID!) {
  getConversation(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, baseOptions);
      }
export function useGetConversationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, baseOptions);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationQueryResult = ApolloReactCommon.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const GetMessageDocument = gql`
    query getMessage($id: ID!) {
  getMessage(id: $id) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
        return ApolloReactHooks.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, baseOptions);
      }
export function useGetMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, baseOptions);
        }
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageQueryResult = ApolloReactCommon.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const LoginDocument = gql`
    mutation login($id: ID!, $token: String!) {
  login(id: $id, token: $token)
}
    `;
export type LoginMutationFn = ApolloReactCommon.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      id: // value for 'id'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = ApolloReactCommon.MutationResult<LoginMutation>;
export type LoginMutationOptions = ApolloReactCommon.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout($token: String!) {
  logout(token: $token)
}
    `;
export type LogoutMutationFn = ApolloReactCommon.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = ApolloReactCommon.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = ApolloReactCommon.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RegisterDocument = gql`
    mutation register($phoneNumber: String!) {
  register(phoneNumber: $phoneNumber) {
    id
    jwtToken
    refreshToken
  }
}
    `;
export type RegisterMutationFn = ApolloReactCommon.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        return ApolloReactHooks.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, baseOptions);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = ApolloReactCommon.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RegisterLawyerDocument = gql`
    mutation registerLawyer($phoneNumber: String!, $inviteCode: String!) {
  registerLawyer(phoneNumber: $phoneNumber, inviteCode: $inviteCode) {
    id
    jwtToken
    refreshToken
  }
}
    `;
export type RegisterLawyerMutationFn = ApolloReactCommon.MutationFunction<RegisterLawyerMutation, RegisterLawyerMutationVariables>;

/**
 * __useRegisterLawyerMutation__
 *
 * To run a mutation, you first call `useRegisterLawyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLawyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLawyerMutation, { data, loading, error }] = useRegisterLawyerMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useRegisterLawyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterLawyerMutation, RegisterLawyerMutationVariables>) {
        return ApolloReactHooks.useMutation<RegisterLawyerMutation, RegisterLawyerMutationVariables>(RegisterLawyerDocument, baseOptions);
      }
export type RegisterLawyerMutationHookResult = ReturnType<typeof useRegisterLawyerMutation>;
export type RegisterLawyerMutationResult = ApolloReactCommon.MutationResult<RegisterLawyerMutation>;
export type RegisterLawyerMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterLawyerMutation, RegisterLawyerMutationVariables>;
export const SendNewPhoneNumberTokenDocument = gql`
    mutation sendNewPhoneNumberToken {
  sendNewPhoneNumberToken
}
    `;
export type SendNewPhoneNumberTokenMutationFn = ApolloReactCommon.MutationFunction<SendNewPhoneNumberTokenMutation, SendNewPhoneNumberTokenMutationVariables>;

/**
 * __useSendNewPhoneNumberTokenMutation__
 *
 * To run a mutation, you first call `useSendNewPhoneNumberTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewPhoneNumberTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewPhoneNumberTokenMutation, { data, loading, error }] = useSendNewPhoneNumberTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendNewPhoneNumberTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendNewPhoneNumberTokenMutation, SendNewPhoneNumberTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<SendNewPhoneNumberTokenMutation, SendNewPhoneNumberTokenMutationVariables>(SendNewPhoneNumberTokenDocument, baseOptions);
      }
export type SendNewPhoneNumberTokenMutationHookResult = ReturnType<typeof useSendNewPhoneNumberTokenMutation>;
export type SendNewPhoneNumberTokenMutationResult = ApolloReactCommon.MutationResult<SendNewPhoneNumberTokenMutation>;
export type SendNewPhoneNumberTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<SendNewPhoneNumberTokenMutation, SendNewPhoneNumberTokenMutationVariables>;
export const SubmitPhoneNumberTokenDocument = gql`
    mutation submitPhoneNumberToken($token: String!) {
  submitPhoneNumberToken(token: $token)
}
    `;
export type SubmitPhoneNumberTokenMutationFn = ApolloReactCommon.MutationFunction<SubmitPhoneNumberTokenMutation, SubmitPhoneNumberTokenMutationVariables>;

/**
 * __useSubmitPhoneNumberTokenMutation__
 *
 * To run a mutation, you first call `useSubmitPhoneNumberTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPhoneNumberTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPhoneNumberTokenMutation, { data, loading, error }] = useSubmitPhoneNumberTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSubmitPhoneNumberTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitPhoneNumberTokenMutation, SubmitPhoneNumberTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitPhoneNumberTokenMutation, SubmitPhoneNumberTokenMutationVariables>(SubmitPhoneNumberTokenDocument, baseOptions);
      }
export type SubmitPhoneNumberTokenMutationHookResult = ReturnType<typeof useSubmitPhoneNumberTokenMutation>;
export type SubmitPhoneNumberTokenMutationResult = ApolloReactCommon.MutationResult<SubmitPhoneNumberTokenMutation>;
export type SubmitPhoneNumberTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitPhoneNumberTokenMutation, SubmitPhoneNumberTokenMutationVariables>;
export const CreateConversationDocument = gql`
    mutation createConversation($title: String!, $topicId: ID!) {
  createConversation(title: $title, topicId: $topicId) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;
export type CreateConversationMutationFn = ApolloReactCommon.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, baseOptions);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = ApolloReactCommon.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const MarkConversationAsLookingForLawyerDocument = gql`
    mutation markConversationAsLookingForLawyer($id: ID!) {
  markConversationAsLookingForLawyer(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;
export type MarkConversationAsLookingForLawyerMutationFn = ApolloReactCommon.MutationFunction<MarkConversationAsLookingForLawyerMutation, MarkConversationAsLookingForLawyerMutationVariables>;

/**
 * __useMarkConversationAsLookingForLawyerMutation__
 *
 * To run a mutation, you first call `useMarkConversationAsLookingForLawyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationAsLookingForLawyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationAsLookingForLawyerMutation, { data, loading, error }] = useMarkConversationAsLookingForLawyerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkConversationAsLookingForLawyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkConversationAsLookingForLawyerMutation, MarkConversationAsLookingForLawyerMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkConversationAsLookingForLawyerMutation, MarkConversationAsLookingForLawyerMutationVariables>(MarkConversationAsLookingForLawyerDocument, baseOptions);
      }
export type MarkConversationAsLookingForLawyerMutationHookResult = ReturnType<typeof useMarkConversationAsLookingForLawyerMutation>;
export type MarkConversationAsLookingForLawyerMutationResult = ApolloReactCommon.MutationResult<MarkConversationAsLookingForLawyerMutation>;
export type MarkConversationAsLookingForLawyerMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkConversationAsLookingForLawyerMutation, MarkConversationAsLookingForLawyerMutationVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($conversationId: ID!, $textContent: String, $imageContent: Upload, $voiceContent: Upload) {
  sendMessage(conversationId: $conversationId, textContent: $textContent, imageContent: $imageContent, voiceContent: $voiceContent) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type SendMessageMutationFn = ApolloReactCommon.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      textContent: // value for 'textContent'
 *      imageContent: // value for 'imageContent'
 *      voiceContent: // value for 'voiceContent'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, baseOptions);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = ApolloReactCommon.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const RemoveMessageDocument = gql`
    mutation removeMessage($id: ID!) {
  removeMessage(id: $id) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type RemoveMessageMutationFn = ApolloReactCommon.MutationFunction<RemoveMessageMutation, RemoveMessageMutationVariables>;

/**
 * __useRemoveMessageMutation__
 *
 * To run a mutation, you first call `useRemoveMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMessageMutation, { data, loading, error }] = useRemoveMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveMessageMutation, RemoveMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveMessageMutation, RemoveMessageMutationVariables>(RemoveMessageDocument, baseOptions);
      }
export type RemoveMessageMutationHookResult = ReturnType<typeof useRemoveMessageMutation>;
export type RemoveMessageMutationResult = ApolloReactCommon.MutationResult<RemoveMessageMutation>;
export type RemoveMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveMessageMutation, RemoveMessageMutationVariables>;
export const UndoRemoveMessageDocument = gql`
    mutation undoRemoveMessage($id: ID!) {
  undoRemoveMessage(id: $id) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type UndoRemoveMessageMutationFn = ApolloReactCommon.MutationFunction<UndoRemoveMessageMutation, UndoRemoveMessageMutationVariables>;

/**
 * __useUndoRemoveMessageMutation__
 *
 * To run a mutation, you first call `useUndoRemoveMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoRemoveMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoRemoveMessageMutation, { data, loading, error }] = useUndoRemoveMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoRemoveMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndoRemoveMessageMutation, UndoRemoveMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<UndoRemoveMessageMutation, UndoRemoveMessageMutationVariables>(UndoRemoveMessageDocument, baseOptions);
      }
export type UndoRemoveMessageMutationHookResult = ReturnType<typeof useUndoRemoveMessageMutation>;
export type UndoRemoveMessageMutationResult = ApolloReactCommon.MutationResult<UndoRemoveMessageMutation>;
export type UndoRemoveMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<UndoRemoveMessageMutation, UndoRemoveMessageMutationVariables>;
export const EditTextMessageDocument = gql`
    mutation editTextMessage($id: ID!, $textContent: String!) {
  editTextMessage(id: $id, textContent: $textContent) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type EditTextMessageMutationFn = ApolloReactCommon.MutationFunction<EditTextMessageMutation, EditTextMessageMutationVariables>;

/**
 * __useEditTextMessageMutation__
 *
 * To run a mutation, you first call `useEditTextMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTextMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTextMessageMutation, { data, loading, error }] = useEditTextMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      textContent: // value for 'textContent'
 *   },
 * });
 */
export function useEditTextMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditTextMessageMutation, EditTextMessageMutationVariables>) {
        return ApolloReactHooks.useMutation<EditTextMessageMutation, EditTextMessageMutationVariables>(EditTextMessageDocument, baseOptions);
      }
export type EditTextMessageMutationHookResult = ReturnType<typeof useEditTextMessageMutation>;
export type EditTextMessageMutationResult = ApolloReactCommon.MutationResult<EditTextMessageMutation>;
export type EditTextMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<EditTextMessageMutation, EditTextMessageMutationVariables>;
export const RemoveConversationDocument = gql`
    mutation removeConversation($id: ID!) {
  removeConversation(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;
export type RemoveConversationMutationFn = ApolloReactCommon.MutationFunction<RemoveConversationMutation, RemoveConversationMutationVariables>;

/**
 * __useRemoveConversationMutation__
 *
 * To run a mutation, you first call `useRemoveConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConversationMutation, { data, loading, error }] = useRemoveConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveConversationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveConversationMutation, RemoveConversationMutationVariables>) {
        return ApolloReactHooks.useMutation<RemoveConversationMutation, RemoveConversationMutationVariables>(RemoveConversationDocument, baseOptions);
      }
export type RemoveConversationMutationHookResult = ReturnType<typeof useRemoveConversationMutation>;
export type RemoveConversationMutationResult = ApolloReactCommon.MutationResult<RemoveConversationMutation>;
export type RemoveConversationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveConversationMutation, RemoveConversationMutationVariables>;
export const SubmitNotificationTokenDocument = gql`
    mutation submitNotificationToken($token: String!) {
  submitNotificationToken(token: $token)
}
    `;
export type SubmitNotificationTokenMutationFn = ApolloReactCommon.MutationFunction<SubmitNotificationTokenMutation, SubmitNotificationTokenMutationVariables>;

/**
 * __useSubmitNotificationTokenMutation__
 *
 * To run a mutation, you first call `useSubmitNotificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNotificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNotificationTokenMutation, { data, loading, error }] = useSubmitNotificationTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSubmitNotificationTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitNotificationTokenMutation, SubmitNotificationTokenMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitNotificationTokenMutation, SubmitNotificationTokenMutationVariables>(SubmitNotificationTokenDocument, baseOptions);
      }
export type SubmitNotificationTokenMutationHookResult = ReturnType<typeof useSubmitNotificationTokenMutation>;
export type SubmitNotificationTokenMutationResult = ApolloReactCommon.MutationResult<SubmitNotificationTokenMutation>;
export type SubmitNotificationTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitNotificationTokenMutation, SubmitNotificationTokenMutationVariables>;
export const AcceptCaseDocument = gql`
    mutation acceptCase($id: ID!) {
  acceptCase(id: $id) {
    ...CaseInfo
  }
}
    ${CaseInfoFragmentDoc}`;
export type AcceptCaseMutationFn = ApolloReactCommon.MutationFunction<AcceptCaseMutation, AcceptCaseMutationVariables>;

/**
 * __useAcceptCaseMutation__
 *
 * To run a mutation, you first call `useAcceptCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCaseMutation, { data, loading, error }] = useAcceptCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptCaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptCaseMutation, AcceptCaseMutationVariables>) {
        return ApolloReactHooks.useMutation<AcceptCaseMutation, AcceptCaseMutationVariables>(AcceptCaseDocument, baseOptions);
      }
export type AcceptCaseMutationHookResult = ReturnType<typeof useAcceptCaseMutation>;
export type AcceptCaseMutationResult = ApolloReactCommon.MutationResult<AcceptCaseMutation>;
export type AcceptCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptCaseMutation, AcceptCaseMutationVariables>;
export const ResolveCaseDocument = gql`
    mutation resolveCase($id: ID!) {
  resolveCase(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;
export type ResolveCaseMutationFn = ApolloReactCommon.MutationFunction<ResolveCaseMutation, ResolveCaseMutationVariables>;

/**
 * __useResolveCaseMutation__
 *
 * To run a mutation, you first call `useResolveCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveCaseMutation, { data, loading, error }] = useResolveCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResolveCaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveCaseMutation, ResolveCaseMutationVariables>) {
        return ApolloReactHooks.useMutation<ResolveCaseMutation, ResolveCaseMutationVariables>(ResolveCaseDocument, baseOptions);
      }
export type ResolveCaseMutationHookResult = ReturnType<typeof useResolveCaseMutation>;
export type ResolveCaseMutationResult = ApolloReactCommon.MutationResult<ResolveCaseMutation>;
export type ResolveCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<ResolveCaseMutation, ResolveCaseMutationVariables>;
export const UnresolveCaseDocument = gql`
    mutation unresolveCase($id: ID!) {
  unresolveCase(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;
export type UnresolveCaseMutationFn = ApolloReactCommon.MutationFunction<UnresolveCaseMutation, UnresolveCaseMutationVariables>;

/**
 * __useUnresolveCaseMutation__
 *
 * To run a mutation, you first call `useUnresolveCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnresolveCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unresolveCaseMutation, { data, loading, error }] = useUnresolveCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnresolveCaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnresolveCaseMutation, UnresolveCaseMutationVariables>) {
        return ApolloReactHooks.useMutation<UnresolveCaseMutation, UnresolveCaseMutationVariables>(UnresolveCaseDocument, baseOptions);
      }
export type UnresolveCaseMutationHookResult = ReturnType<typeof useUnresolveCaseMutation>;
export type UnresolveCaseMutationResult = ApolloReactCommon.MutationResult<UnresolveCaseMutation>;
export type UnresolveCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<UnresolveCaseMutation, UnresolveCaseMutationVariables>;
export const MessagesDocument = gql`
    subscription messages($conversationId: ID!) {
  messages(conversationId: $conversationId) {
    type
    message {
      ...MessageInfo
    }
  }
}
    ${MessageInfoFragmentDoc}`;

/**
 * __useMessagesSubscription__
 *
 * To run a query within a React component, call `useMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useMessagesSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MessagesSubscription, MessagesSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<MessagesSubscription, MessagesSubscriptionVariables>(MessagesDocument, baseOptions);
      }
export type MessagesSubscriptionHookResult = ReturnType<typeof useMessagesSubscription>;
export type MessagesSubscriptionResult = ApolloReactCommon.SubscriptionResult<MessagesSubscription>;
export const ConversationsDocument = gql`
    subscription conversations($status: [ConversationStatus!]) {
  conversations(status: $status) {
    type
    conversation {
      ...ConversationInfo
    }
  }
}
    ${ConversationInfoFragmentDoc}`;

/**
 * __useConversationsSubscription__
 *
 * To run a query within a React component, call `useConversationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationsSubscription({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useConversationsSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ConversationsSubscription, ConversationsSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ConversationsSubscription, ConversationsSubscriptionVariables>(ConversationsDocument, baseOptions);
      }
export type ConversationsSubscriptionHookResult = ReturnType<typeof useConversationsSubscription>;
export type ConversationsSubscriptionResult = ApolloReactCommon.SubscriptionResult<ConversationsSubscription>;
export const ConversationDocument = gql`
    subscription conversation($id: ID!) {
  conversation(id: $id) {
    ...ConversationInfo
  }
}
    ${ConversationInfoFragmentDoc}`;

/**
 * __useConversationSubscription__
 *
 * To run a query within a React component, call `useConversationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<ConversationSubscription, ConversationSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<ConversationSubscription, ConversationSubscriptionVariables>(ConversationDocument, baseOptions);
      }
export type ConversationSubscriptionHookResult = ReturnType<typeof useConversationSubscription>;
export type ConversationSubscriptionResult = ApolloReactCommon.SubscriptionResult<ConversationSubscription>;
export const PendingCaseDocument = gql`
    subscription pendingCase {
  pendingCase {
    pendingCase {
      ...CaseInfoWithInitialMessages
    }
  }
}
    ${CaseInfoWithInitialMessagesFragmentDoc}`;

/**
 * __usePendingCaseSubscription__
 *
 * To run a query within a React component, call `usePendingCaseSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePendingCaseSubscription` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingCaseSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePendingCaseSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<PendingCaseSubscription, PendingCaseSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<PendingCaseSubscription, PendingCaseSubscriptionVariables>(PendingCaseDocument, baseOptions);
      }
export type PendingCaseSubscriptionHookResult = ReturnType<typeof usePendingCaseSubscription>;
export type PendingCaseSubscriptionResult = ApolloReactCommon.SubscriptionResult<PendingCaseSubscription>;


export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs>;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>,
  ConversationTopicCategory: ResolverTypeWrapper<ConversationTopicCategory>,
  ID: ResolverTypeWrapper<Scalars['ID']>,
  String: ResolverTypeWrapper<Scalars['String']>,
  ConversationTopic: ResolverTypeWrapper<ConversationTopic>,
  GettingStartedExample: ResolverTypeWrapper<GettingStartedExample>,
  CurrentUser: ResolverTypeWrapper<CurrentUser>,
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>,
  UserStatus: UserStatus,
  User: ResolverTypeWrapper<User>,
  Int: ResolverTypeWrapper<Scalars['Int']>,
  Case: ResolverTypeWrapper<Case>,
  Date: ResolverTypeWrapper<Scalars['Date']>,
  Message: ResolverTypeWrapper<Omit<Message, 'content'> & { content: ResolversTypes['Content'] }>,
  Content: ResolversTypes['AudioContent'] | ResolversTypes['ImageContent'] | ResolversTypes['TextContent'],
  AudioContent: ResolverTypeWrapper<AudioContent>,
  StoredAsset: ResolverTypeWrapper<StoredAsset>,
  ImageContent: ResolverTypeWrapper<ImageContent>,
  TextContent: ResolverTypeWrapper<TextContent>,
  Conversation: ResolverTypeWrapper<Conversation>,
  Client: ResolverTypeWrapper<Client>,
  Lawyer: ResolverTypeWrapper<Lawyer>,
  ConversationStatus: ConversationStatus,
  Mutation: ResolverTypeWrapper<{}>,
  RegisterOutput: ResolverTypeWrapper<RegisterOutput>,
  Upload: ResolverTypeWrapper<Scalars['Upload']>,
  Subscription: ResolverTypeWrapper<{}>,
  EventType: EventType,
  ConversationEvent: ResolverTypeWrapper<ConversationEvent>,
  MessageEvent: ResolverTypeWrapper<MessageEvent>,
  PendingCaseEvent: ResolverTypeWrapper<PendingCaseEvent>,
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {},
  ConversationTopicCategory: ConversationTopicCategory,
  ID: Scalars['ID'],
  String: Scalars['String'],
  ConversationTopic: ConversationTopic,
  GettingStartedExample: GettingStartedExample,
  CurrentUser: CurrentUser,
  Boolean: Scalars['Boolean'],
  UserStatus: UserStatus,
  User: User,
  Int: Scalars['Int'],
  Case: Case,
  Date: Scalars['Date'],
  Message: Omit<Message, 'content'> & { content: ResolversParentTypes['Content'] },
  Content: ResolversParentTypes['AudioContent'] | ResolversParentTypes['ImageContent'] | ResolversParentTypes['TextContent'],
  AudioContent: AudioContent,
  StoredAsset: StoredAsset,
  ImageContent: ImageContent,
  TextContent: TextContent,
  Conversation: Conversation,
  Client: Client,
  Lawyer: Lawyer,
  ConversationStatus: ConversationStatus,
  Mutation: {},
  RegisterOutput: RegisterOutput,
  Upload: Scalars['Upload'],
  Subscription: {},
  EventType: EventType,
  ConversationEvent: ConversationEvent,
  MessageEvent: MessageEvent,
  PendingCaseEvent: PendingCaseEvent,
};

export type AudioContentResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['AudioContent'] = ResolversParentTypes['AudioContent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  audio?: Resolver<ResolversTypes['StoredAsset'], ParentType, ContextType>,
};

export type CaseResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Case'] = ResolversParentTypes['Case']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
  initialMessages?: Resolver<ReadonlyArray<ResolversTypes['Message']>, ParentType, ContextType>,
  topic?: Resolver<ResolversTypes['ConversationTopic'], ParentType, ContextType>,
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
};

export type ClientResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Client'] = ResolversParentTypes['Client']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  isMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
};

export type ContentResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Content'] = ResolversParentTypes['Content']> = {
  __resolveType: TypeResolveFn<'AudioContent' | 'ImageContent' | 'TextContent', ParentType, ContextType>
};

export type ConversationResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Conversation'] = ResolversParentTypes['Conversation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  case?: Resolver<ResolversTypes['Case'], ParentType, ContextType>,
  client?: Resolver<ResolversTypes['Client'], ParentType, ContextType>,
  lawyer?: Resolver<Maybe<ResolversTypes['Lawyer']>, ParentType, ContextType>,
  status?: Resolver<ResolversTypes['ConversationStatus'], ParentType, ContextType>,
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
  lastMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>,
  lastMessageUpdatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
};

export type ConversationEventResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['ConversationEvent'] = ResolversParentTypes['ConversationEvent']> = {
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>,
  conversation?: Resolver<ResolversTypes['Conversation'], ParentType, ContextType>,
};

export type ConversationTopicResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['ConversationTopic'] = ResolversParentTypes['ConversationTopic']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  category?: Resolver<ResolversTypes['ConversationTopicCategory'], ParentType, ContextType>,
  examples?: Resolver<ReadonlyArray<ResolversTypes['GettingStartedExample']>, ParentType, ContextType>,
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
};

export type ConversationTopicCategoryResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['ConversationTopicCategory'] = ResolversParentTypes['ConversationTopicCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  topics?: Resolver<ReadonlyArray<ResolversTypes['ConversationTopic']>, ParentType, ContextType>,
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
};

export type CurrentUserResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['CurrentUser'] = ResolversParentTypes['CurrentUser']> = {
  hasNotificationAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>,
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>,
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date'
}

export type GettingStartedExampleResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['GettingStartedExample'] = ResolversParentTypes['GettingStartedExample']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  topic?: Resolver<ResolversTypes['ConversationTopic'], ParentType, ContextType>,
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
};

export type ImageContentResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['ImageContent'] = ResolversParentTypes['ImageContent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  image?: Resolver<ResolversTypes['StoredAsset'], ParentType, ContextType>,
};

export type LawyerResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Lawyer'] = ResolversParentTypes['Lawyer']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  isMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
  lawyerTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>,
};

export type MessageResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  author?: Resolver<ResolversTypes['User'], ParentType, ContextType>,
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
  content?: Resolver<ResolversTypes['Content'], ParentType, ContextType>,
  conversation?: Resolver<ResolversTypes['Conversation'], ParentType, ContextType>,
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>,
};

export type MessageEventResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['MessageEvent'] = ResolversParentTypes['MessageEvent']> = {
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>,
  message?: Resolver<ResolversTypes['Message'], ParentType, ContextType>,
};

export type MutationResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  register?: Resolver<Maybe<ResolversTypes['RegisterOutput']>, ParentType, ContextType, RequireFields<MutationRegisterArgs, 'phoneNumber'>>,
  registerLawyer?: Resolver<Maybe<ResolversTypes['RegisterOutput']>, ParentType, ContextType, RequireFields<MutationRegisterLawyerArgs, 'phoneNumber' | 'inviteCode'>>,
  login?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationLoginArgs, 'id' | 'token'>>,
  logout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationLogoutArgs, 'token'>>,
  sendNewPhoneNumberToken?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>,
  submitPhoneNumberToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSubmitPhoneNumberTokenArgs, 'token'>>,
  submitNotificationToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSubmitNotificationTokenArgs, 'token'>>,
  createConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationCreateConversationArgs, 'title' | 'topicId'>>,
  markConversationAsLookingForLawyer?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationMarkConversationAsLookingForLawyerArgs, 'id'>>,
  removeConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationRemoveConversationArgs, 'id'>>,
  sendMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'conversationId'>>,
  removeMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationRemoveMessageArgs, 'id'>>,
  undoRemoveMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationUndoRemoveMessageArgs, 'id'>>,
  editTextMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationEditTextMessageArgs, 'id' | 'textContent'>>,
  acceptCase?: Resolver<Maybe<ResolversTypes['Case']>, ParentType, ContextType, RequireFields<MutationAcceptCaseArgs, 'id'>>,
  resolveCase?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationResolveCaseArgs, 'id'>>,
  unresolveCase?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<MutationUnresolveCaseArgs, 'id'>>,
};

export type PendingCaseEventResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['PendingCaseEvent'] = ResolversParentTypes['PendingCaseEvent']> = {
  pendingCase?: Resolver<ResolversTypes['Case'], ParentType, ContextType>,
};

export type QueryResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getTopicCategories?: Resolver<Maybe<ReadonlyArray<ResolversTypes['ConversationTopicCategory']>>, ParentType, ContextType>,
  currentUser?: Resolver<Maybe<ResolversTypes['CurrentUser']>, ParentType, ContextType>,
  getPendingCases?: Resolver<Maybe<ReadonlyArray<ResolversTypes['Case']>>, ParentType, ContextType, QueryGetPendingCasesArgs>,
  getMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<QueryGetMessageArgs, 'id'>>,
  getMessages?: Resolver<Maybe<ReadonlyArray<ResolversTypes['Message']>>, ParentType, ContextType, RequireFields<QueryGetMessagesArgs, 'conversationId'>>,
  getConversation?: Resolver<Maybe<ResolversTypes['Conversation']>, ParentType, ContextType, RequireFields<QueryGetConversationArgs, 'id'>>,
  getConversations?: Resolver<Maybe<ReadonlyArray<ResolversTypes['Conversation']>>, ParentType, ContextType, QueryGetConversationsArgs>,
};

export type RegisterOutputResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['RegisterOutput'] = ResolversParentTypes['RegisterOutput']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  jwtToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
};

export type StoredAssetResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['StoredAsset'] = ResolversParentTypes['StoredAsset']> = {
  presignedUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
};

export type SubscriptionResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  conversations?: SubscriptionResolver<Maybe<ResolversTypes['ConversationEvent']>, "conversations", ParentType, ContextType, SubscriptionConversationsArgs>,
  conversation?: SubscriptionResolver<Maybe<ResolversTypes['Conversation']>, "conversation", ParentType, ContextType, RequireFields<SubscriptionConversationArgs, 'id'>>,
  messages?: SubscriptionResolver<Maybe<ResolversTypes['MessageEvent']>, "messages", ParentType, ContextType, RequireFields<SubscriptionMessagesArgs, 'conversationId'>>,
  pendingCase?: SubscriptionResolver<Maybe<ResolversTypes['PendingCaseEvent']>, "pendingCase", ParentType, ContextType>,
};

export type TextContentResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['TextContent'] = ResolversParentTypes['TextContent']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>,
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload'
}

export type UserResolvers<ContextType = GraphQLContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  __resolveType: TypeResolveFn<'Client' | 'Lawyer', ParentType, ContextType>,
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>,
  isMe?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>,
};

export type Resolvers<ContextType = GraphQLContext> = {
  AudioContent?: AudioContentResolvers<ContextType>,
  Case?: CaseResolvers<ContextType>,
  Client?: ClientResolvers<ContextType>,
  Content?: ContentResolvers,
  Conversation?: ConversationResolvers<ContextType>,
  ConversationEvent?: ConversationEventResolvers<ContextType>,
  ConversationTopic?: ConversationTopicResolvers<ContextType>,
  ConversationTopicCategory?: ConversationTopicCategoryResolvers<ContextType>,
  CurrentUser?: CurrentUserResolvers<ContextType>,
  Date?: GraphQLScalarType,
  GettingStartedExample?: GettingStartedExampleResolvers<ContextType>,
  ImageContent?: ImageContentResolvers<ContextType>,
  Lawyer?: LawyerResolvers<ContextType>,
  Message?: MessageResolvers<ContextType>,
  MessageEvent?: MessageEventResolvers<ContextType>,
  Mutation?: MutationResolvers<ContextType>,
  PendingCaseEvent?: PendingCaseEventResolvers<ContextType>,
  Query?: QueryResolvers<ContextType>,
  RegisterOutput?: RegisterOutputResolvers<ContextType>,
  StoredAsset?: StoredAssetResolvers<ContextType>,
  Subscription?: SubscriptionResolvers<ContextType>,
  TextContent?: TextContentResolvers<ContextType>,
  Upload?: GraphQLScalarType,
  User?: UserResolvers,
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
*/
export type IResolvers<ContextType = GraphQLContext> = Resolvers<ContextType>;
